<template>
  <v-data-table class="elevation-1"
                :headers="headers"
                :items="patients"
                :loading="progress('patients.getPatients')"
                :server-items-length="totalPatients"
                no-data-text="No patients"
                :options.sync="innerDataTableOptions"
                :footer-props="{
                    itemsPerPageText: 'Patients per page',
                    itemsPerPageOptions: [10, 25, 40]
                  }"
                dense>
    <template v-slot:item="props">
      <Item :item="props.item"
            :available-clients-by-id="clientsById">
      </Item>
    </template>
  </v-data-table>
</template>

<script>

import {mapActions, mapState, mapGetters} from 'vuex'

import Item from './PatientListItem'
import _ from 'lodash'

export default {
  name: 'PatientList',
  components: {
    Item,
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          width: '300px',
          value: 'name',
        },
        {
          text: 'Birthday',
          align: 'start',
          sortable: true,
          width: '60px',
          value: 'birthday',
        },
        {
          text: 'Created',
          align: 'start',
          sortable: true,
          width: '150px',
          value: 'created_at',
        },
        {
          text: 'Clients',
          align: 'start',
          sortable: false,
          width: '300px'
        },
        {
          text: 'Cases',
          align: 'start',
          sortable: false,
          width: '200px'
        },
        {
          text: 'Comment',
          align: 'start',
          sortable: false,
        }
      ],
      innerDataTableOptions: _.cloneDeep(this.$store.state.patients.dataTableOptions),
    }
  },
  watch: {
    innerDataTableOptions: {
      async handler(newOptions) {
        this.changeDataTableOptions(newOptions)
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters({
      progress: 'progress'
    }),
    ...mapGetters('clients', {
      clientsById: 'clientsById'
    }),
    ...mapState('patients', {
      patients: 'patients',
      totalPatients: 'totalPatients'
    })
  },
  methods: {
    ...mapActions('patients', {
      changeDataTableOptions: 'changeDataTableOptions'
    }),
    handleItemClick() {
    }
  }
}
</script>

<style scoped>

</style>